import React from "react";

export default function ModuleCoverage() {
  return (
    <div className="container py-5" style={{ marginTop: "50px", marginBottom: "50px" }}>
      <h2 className="fw-bold text-center text-danger title split-collab" style={{fontSize: "clamp(1.7rem, 5vw, 3.3rem)"}}>
        OUR COMPREHENSIVE MODULE COVERAGE
      </h2>
      <hr className="my-4" />

      <div className="d-flex flex-column flex-md-row justify-content-between">
        {/* Image Section (Unchanged) */}
        <div
          className="d-flex flex-column justify-content-center mb-4 mb-md-0"
          data-sal-delay="150"
          data-sal="slide-up"
          data-sal-duration="800"
          style={{ flex: 1 }}
        >
          <div className="d-flex justify-content-center flex-wrap">
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture1.png" alt="Module Image 1" className="img-fluid rounded border" style={{ width: "180px", height: "180px", objectFit: "cover" }} />
            </div>
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture2.png" alt="Module Image 2" className="img-fluid rounded border" style={{ width: "180px", height: "180px", objectFit: "cover" }} />
            </div>
          </div>
          <div className="d-flex justify-content-center flex-wrap">
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture3.png" alt="Module Image 3" className="img-fluid rounded border" style={{ width: "180px", height: "180px", objectFit: "cover" }} />
            </div>
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture4.png" alt="Module Image 4" className="img-fluid rounded border" style={{ width: "180px", height: "180px", objectFit: "cover" }} />
            </div>
          </div>
          <div className="d-flex justify-content-center flex-wrap">
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture5.png" alt="Module Image 5" className="img-fluid rounded border" style={{ width: "370px", height: "200px", objectFit: "cover" }} />
            </div>
          </div>
          <div className="d-flex justify-content-center flex-wrap">
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture6.png" alt="Module Image 6" className="img-fluid rounded border" style={{ width: "120px", height: "120px", objectFit: "cover" }} />
            </div>
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture7.png" alt="Module Image 7" className="img-fluid rounded border" style={{ width: "120px", height: "120px", objectFit: "cover" }} />
            </div>
            <div className="p-2">
              <img src="../assets/images/OUR_COMPREHENSIVE_MODULE_COVERAGE/Picture8.png" alt="Module Image 8" className="img-fluid rounded border" style={{ width: "120px", height: "120px", objectFit: "cover" }} />
            </div>
          </div>
        </div>

        {/* Module Content Section with Inline SVGs */}
        <div className="d-flex flex-column gap-5 align-items-start ps-md-5" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800" style={{ flex: 1 }}>
          {[
            {
              number: "01",
              color: "#ba68c8",
              text: "CENTRE BOOKING AND AUDIT MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M6 2v2H4a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H8V2H6zm14 6v12H4V8h16zM7 10h5v5H7v-5z"/></svg>
              ),
            },
            {
              number: "02",
              color: "#f06292",
              text: "INVENTORY MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zm0 7L4 9v10l8 4 8-4V9l-8 1z"/></svg>
              ),
            },
            {
              number: "03",
              color: "#dce775",
              text: "MANPOWER MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4z"/></svg>
              ),
            },
            {
              number: "04",
              color: "#aed581",
              text: "EXAMINATION PROCESS MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M5 3h14a2 2 0 0 1 2 2v16l-4-4H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/></svg>
              ),
            },
            {
              number: "05",
              color: "#009688",
              text: "SECURITY MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M12 1l9 4v6c0 5.25-3.5 10-9 11-5.5-1-9-5.75-9-11V5l9-4z"/></svg>
              ),
            },
            {
              number: "06",
              color: "#3f51b5",
              text: "DATA MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M5 20h14v-2H5v2zm7-18L5.33 9h4.67v6h4V9h4.67L12 2z"/></svg>
              ),
            },
            {
              number: "07",
              color: "#ba68c8",
              text: "POST EXAMINATION MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><circle cx="12" cy="12" r="2"/><path d="M4 12a8 8 0 0 1 16 0h2a10 10 0 1 0-20 0h2z"/></svg>
              ),
            },
            {
              number: "08",
              color: "#f06292",
              text: "QUALITY CONTROL MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><circle cx="12" cy="12" r="2"/><path d="M4 12a8 8 0 0 1 16 0h2a10 10 0 1 0-20 0h2z"/></svg>
              ),
            },
            {
              number: "09",
              color: "#dce775",
              text: "CRISIS MANAGEMENT",
              icon: (
                <svg width="18" height="18" fill="black" viewBox="0 0 24 24"><path d="M1 21h22L12 2 1 21zm13-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
              ),
            },
          ].map((item, index) => (
            <div key={index} className="d-flex align-items-center mb-3">
              <div style={{ backgroundColor: item.color, width: "50px", color: item.color === "#dce775" ? "black" : "white" }} className="py-2 px-2 fw-bold text-center">{item.number}</div>
              <div style={{ height: "30px", width: "30px", backgroundColor: "#f8bbd0" }} className="rounded-circle d-flex align-items-center justify-content-center ms-2">
                {item.icon}
              </div>
              <div className="ms-3 fw-bold">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
